var styles = {
  "Link": "pb-Link__Link",
  "Link--strong": "pb-Link__Link--strong",
  "Link--likeButton": "pb-Link__Link--likeButton",
  "Link--buttonPadding": "pb-Link__Link--buttonPadding",
  "Link--withIconSlotLeft": "pb-Link__Link--withIconSlotLeft",
  "Link--withIconSlotRight": "pb-Link__Link--withIconSlotRight",
  "text": "pb-Link__text"
};
export default styles;